import { IRDoc, PublicDocument } from "src/models/Doc";
import { useQuery } from "@tanstack/react-query";
import { Markdown } from "../utils/Markdown";
import irData from "../../content/ir/ir.json";

export const useGetDoc = (id: string) => {
  return useQuery({
    queryKey: [id],
    enabled: !!id,
    queryFn: async (): Promise<PublicDocument | null> => {
      try {
        const res = await fetch(
          `/sdk-api/api/v1/public-documents/${encodeURIComponent(id)}/`,
          {
            method: "GET",
          },
        );
        if (res.ok) {
          const result = await res.json();
          if (result.status) {
            return result.message;
          }
        }
        return null;
      } catch (e) {
        console.error(`useGetDoc(${id}) `, e);
        return null;
      }
    },
  });
};

export const useGetAllIRDocs = () => {
  return useQuery({
    queryKey: ["ir-docs"],
    queryFn: async (): Promise<IRDoc[]> => {
      return irData.posts.map((post) => ({
        ID: post.id,
        title: post.title.ko,
        tags: { [post.tagDate]: {} },
        categories: { [post.category]: {} },
        date: "",
        thumbnail: "",
        content: post.content.ko,
      }));
    },
    staleTime: Infinity,
  });
};
